import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "../../../design-system/components/composite/Modal/Modal";
import { Body, Heading, Item, ItemLabel, Items, Paragraph, Section, SectionHeading } from "./InfoDialog.styles";
import type { InfoDialogProps } from "./InfoDialog.types";

const DEFAULT_TITLE_ID = "info-dialog-title";

/** A read-only dialog of titled sections of plain text. A section without text or entries is not shown. */
export const InfoDialog: React.FC<InfoDialogProps> = ({ isOpen, title, onClose, sections, titleId = DEFAULT_TITLE_ID, action }) => (
  <Modal open={isOpen} onClose={onClose} size="md" ariaLabelledBy={titleId}>
    <ModalHeader onClose={onClose}>
      <Heading id={titleId}>{title}</Heading>
    </ModalHeader>
    <ModalBody padding="0">
      <Body>
        {sections
          .filter((section) => section.text || (section.items?.length ?? 0) > 0)
          .map((section) => (
            <Section key={section.id} aria-label={section.heading}>
              <SectionHeading>{section.heading}</SectionHeading>
              {section.text ? <Paragraph>{section.text}</Paragraph> : null}
              {section.items && section.items.length > 0 ? (
                <Items>
                  {section.items.map((item) => (
                    <Item key={item.id}>
                      {item.label ? <ItemLabel>{item.label}</ItemLabel> : null}
                      <Paragraph>{item.text}</Paragraph>
                    </Item>
                  ))}
                </Items>
              ) : null}
            </Section>
          ))}
      </Body>
    </ModalBody>
    {action ? <ModalFooter>{action}</ModalFooter> : null}
  </Modal>
);

export default InfoDialog;
